<template>
    <div class="form-input" :class="[classString, {'error': error}, {'locked': element.locked === true, 'unlocked' : element.locked === false}]">
        <span v-if="element.isTemplateContentEdit" class="padlock-wrapper"><label><Label :label="element.label" :tooltip="element.tooltip" /></label><Lock :locked="element.locked" @toggleLocked="toggleLockedState($event)" /></span>
        <label v-else class="lock"><Label :label="element.label" :tooltip="element.tooltip" /></label>

        <label v-for="(option, index) in element.options" :key="index" :for="element.name + '-' + index" class="form-radio" >
            <input autocomplete="off" type="radio" :id="element.name + '-' + index" v-model="inputValue" :disabled="element.disabled" :readonly="element.readonly" :value="option.value" @focus="onInputFocusStandard" @blur="onInputBlurStandard" /><span></span> {{option.text}}
        </label>
        <span class="error-message" v-if="error">{{error}}</span>
    </div>
</template>

<script>
    import {formElementMixin} from "@/components/mixins/formelement";

    import Label from "@/components/form/label";
    import Lock from "@/components/form/lock";

    export default {
        name: "Formelement_radio",
        components: {Label, Lock},
        mixins: [formElementMixin],
        props: {
            element: {
                type: Object
            },
            value: {
                type: String
            },
            classString: {
                type: String
            }
        },
        computed: {
            inputValue: {
                get() { return this.value },
                set(inputValue) {this.$emit('input', inputValue)}
            }
        },
    }
</script>